// extracted by mini-css-extract-plugin
export default {"placeholderSearchBoxLoader":"qOQntFj6_Gt1VSm3DRiD","customIconUserLocationContainer":"renBCzoF_bm2Q6oTDyaa"};